import RoutesPages from "./components/Page";

function App() {
  return (
    <div className="App">
      <RoutesPages />
    </div>
  );
}

export default App;
